/**
 * The "verify your phone to back up" reminder an unverified session sees when
 * its address book changes (#476). It appears as a toast of its own after an
 * edit (useAddressBookSync) or as a line in an import's success toast
 * (useImportToast). Both draw on one throttle, so the user sees it at most once
 * per ADDRESS_BOOK_BACKUP_NAG_INTERVAL_MS however it arrived, and an import
 * never shows it twice.
 */

import { ADDRESS_BOOK_BACKUP_NAG_INTERVAL_MS } from '@/modules/config';

/** Where the reminder's Verify button goes. */
export const PHONE_STEP_PATH = '/profile/steps/phone';

let lastShownAt = Number.NEGATIVE_INFINITY;

export const BackupReminder = {
  /** Record that the reminder has just been shown. */
  markShown(now: number = Date.now()): void {
    lastShownAt = now;
  },

  /**
   * Whether the reminder may be shown now. When it may, the showing is
   * recorded, so the caller is expected to show it.
   */
  claim(now: number = Date.now()): boolean {
    if (now - lastShownAt < ADDRESS_BOOK_BACKUP_NAG_INTERVAL_MS) return false;
    lastShownAt = now;
    return true;
  },

  /** Forget the last showing (tests). */
  reset(): void {
    lastShownAt = Number.NEGATIVE_INFINITY;
  },
};
